import router from '@/router'
import { getConfig, ConfigKeys } from '@/common/config'
import { useAuthStore } from '@/stores/auth'
import { http } from '@/common/http/http'
import type { InternalUser } from '@/modules/auth/types/internal_user'

export interface GoogleCredentialResponse {
  credential: string
  clientId: string
  client_id: string
  select_by: string
}

export interface LoginResponse {
  access_token: string
  user: {
    id: string
    subGoogle: string
    email: string
    name: string
    picture?: string
  }
}

const GOOGLE_CLIENT_ID = getConfig(ConfigKeys.GOOGLE_CLIENT_ID)

const getAuthStore = () => {
  return useAuthStore()
}

export async function loginWithGoogle(response: GoogleCredentialResponse) {
  try {
    // The JWT from Google
    const clientId = response.clientId

    if (clientId !== GOOGLE_CLIENT_ID) {
      throw new Error('Invalid client ID')
    }

    const credential = response.credential
    await loginWithCredential(credential)

    router.push('/dashboard')
  } catch (error) {
    console.error('Login failed:', error)
  }
}

export async function loginWithCredential(credential: string): Promise<LoginResponse> {
  const res = await http.post('/admin/auth/login', {
    token: credential,
  })

  const loginResponse = res.data as LoginResponse

  if (!loginResponse.access_token) {
    // TODO: handle error display
    throw new Error('Login failed')
  }

  const internalUser: InternalUser = {
    id: loginResponse.user.id,
    subGoogle: loginResponse.user.subGoogle,
    name: loginResponse.user.name,
    email: loginResponse.user.email,
    picture: loginResponse.user.picture || '',
  }

  getAuthStore().login(credential, loginResponse.access_token, internalUser)

  return loginResponse
}

export function logout() {
  getAuthStore().logout()
  router.push('/login')
}
